/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const UpdatePluginServerFormPolicy = {
  Required: "required",
  Optional: "optional",
} as const;
export type UpdatePluginServerFormPolicy = ClosedEnum<
  typeof UpdatePluginServerFormPolicy
>;

export type UpdatePluginServerForm = {
  displayName: string;
  id: string;
  pluginId: string;
  policy?: UpdatePluginServerFormPolicy | undefined;
  sortOrder?: number | undefined;
};

/** @internal */
export const UpdatePluginServerFormPolicy$outboundSchema: z.ZodMiniEnum<
  typeof UpdatePluginServerFormPolicy
> = z.enum(UpdatePluginServerFormPolicy);

/** @internal */
export type UpdatePluginServerForm$Outbound = {
  display_name: string;
  id: string;
  plugin_id: string;
  policy: string;
  sort_order: number;
};

/** @internal */
export const UpdatePluginServerForm$outboundSchema: z.ZodMiniType<
  UpdatePluginServerForm$Outbound,
  UpdatePluginServerForm
> = z.pipe(
  z.object({
    displayName: z.string(),
    id: z.string(),
    pluginId: z.string(),
    policy: z._default(UpdatePluginServerFormPolicy$outboundSchema, "required"),
    sortOrder: z._default(z.int(), 0),
  }),
  z.transform((v) => {
    return remap$(v, {
      displayName: "display_name",
      pluginId: "plugin_id",
      sortOrder: "sort_order",
    });
  }),
);

export function updatePluginServerFormToJSON(
  updatePluginServerForm: UpdatePluginServerForm,
): string {
  return JSON.stringify(
    UpdatePluginServerForm$outboundSchema.parse(updatePluginServerForm),
  );
}
